import React, { useState, useEffect } from "react";
import Layout from "../Componants/Layout";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, postRequest } from "../services/apiMethods";
import AddServices from "../Modal/AddServices";
import ConfirmModal from "../Modal/ConfirmModal";

export default function YourServices() {
  const Navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [checkedServices, setCheckedServices] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState("");
  const [selectedDeleteCategoriID, setSelectedDeleteCategoriID] = useState("") 
  const [activeKey, setActiveKey] = useState(null); 
  const { data: serviceList, error: queryError, isLoading: load, refetch } = useQuery({
    queryKey: ["categories"],
    queryFn: () => getRequest("/profile/services"),
  });

  // Ensure all checkboxes are checked initially
  useEffect(() => {
    if (serviceList?.data && Array.isArray(serviceList?.data)) {
      const initialCheckedState = {};
      serviceList.data.forEach((ele) => {
        Array.isArray(ele.services) && ele.services.forEach((service) => {
          initialCheckedState[service._id] = true; // Set each service's checkbox to be checked
        });
      });
      setCheckedServices(initialCheckedState);
    }
  }, [serviceList]);


  const handleDelete = (type, categorieID ,subCategory) => {
    setModalOpen(true);
    const values = {
      service: subCategory,
      category: categorieID
    }
    setSelectedType(type);
    setSelectedDeleteCategoriID(values)
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
    setSelectedDeleteCategoriID("")
  };

  const handleAccordionToggle = (key) => {
    // Toggle between opening and closing the accordion
    setActiveKey(activeKey === key ? null : key);
  };

  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3
              className="with-back-btn cursor-pointer"
              onClick={() => Navigate("/settings")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4 12L3.29289 11.2929L2.58579 12L3.29289 12.7071L4 12ZM19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11V13ZM9.29289 5.29289L3.29289 11.2929L4.70711 12.7071L10.7071 6.70711L9.29289 5.29289ZM3.29289 12.7071L9.29289 18.7071L10.7071 17.2929L4.70711 11.2929L3.29289 12.7071ZM4 13H19V11H4V13Z"
                  fill="black"
                />
              </svg>
              Account
            </h3>
            <Row>
              <Col lg={8}>
                <div className="my-profile-card-contain">
                  <div className="my-profile-title">
                    <h4>Your Services</h4>
                    <p>
                    Add or update the services you provide
                    so customers know what you offer.
                    </p>
                  </div>
                  <div className="faq-list-accro">
                    <Accordion
                      activeKey={activeKey}
                      onSelect={handleAccordionToggle}
                      flush
                    >
                      {Array.isArray(serviceList?.data) &&
                        serviceList?.data.map((ele, index) => {
                          return (
                            <Accordion.Item key={index} eventKey={index.toString()}>

                              <Accordion.Header>{ele?.category?.categoryName}</Accordion.Header>
                              <Accordion.Body>
                                <ul className="services-check-list">
                                  {Array.isArray(ele?.services) &&
                                    ele?.services.map((val, index) => {
                                      return (
                                        <li key={index}>
                                          <p>{val?.serviceName}</p>
                                            <input
                                              type="checkbox"
                                              disabled={serviceList?.data?.length === 1 && ele?.services?.length === 1}
                                              checked={checkedServices[val._id] || false} // Check if the service is checked
                                              onChange={() =>
                                                handleDelete("serviceDelete", ele?.category?._id , val._id)
                                              } // Toggle checked state
                                            />
                                          
                                        </li>
                                      );
                                    })}
                                </ul>
                              </Accordion.Body>
                            </Accordion.Item>
                          );
                        })}
                    </Accordion>
                  </div>
                  <div className="ad-services">
                    <button onClick={handleShow}>+ Add More</button>
                  </div>
                </div>
              </Col>
              <Col lg={4}></Col>
            </Row>
          </div>
        </Container>
        <AddServices show={show} handleClose={handleClose} refetch={refetch} />
        <ConfirmModal
          data={selectedDeleteCategoriID}
          isModalOpen={isModalOpen}
          selectedType={selectedType}
          handleConfirmClose={handleConfirmClose}
          refetch={refetch}
        />
      </Layout>
    </>
  );
}
